// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateElSalvadorianDocument(document: string): ?UserInputValidationError {
  if (!document) {
    return { id: 'empty'};
  }
  const eightDigitsRegex = /\d{8}/;
  if (!eightDigitsRegex.test(document)) {
    return { id: 'invalid-pattern' };
  }
}
